import { Box, Grid, Button, IconButton } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import CloseIcon from '@mui/icons-material/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
// Utils and Helpers
import { CARD_TYPE, REPLENISH_FRECUENCY } from 'helpers/constants';
// Assets
import physicalCard from 'assets/createCards/physicalCard.png';
import virtualCard from 'assets/createCards/virtualCard.png';

const validationSchema = Yup.object().shape({
    type: Yup.mixed().oneOf([CARD_TYPE.PHYSICAL, CARD_TYPE.VIRTUAL]).required('Required')
});
const CardType = ({ card, setCardForm, onStepSubmit, onCardModalClose }) => {
    const handleCardTypeClick = (cardType, setFieldValue) => {
        setFieldValue('type', cardType);
        if (cardType === CARD_TYPE.PHYSICAL) {
            setCardForm({
                ...card,
                type: cardType,
                has_manual_replenish: REPLENISH_FRECUENCY.DAILY
            });
        }
    };

    return (
        <Formik initialValues={card} enableReinitialize={true} validationSchema={validationSchema} onSubmit={onStepSubmit}>
            {({ setFieldValue, values }) => (
                <Box className="request-card" sx={{ width: '100%' }}>
                    <Form id="card-type-form">
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box>
                                <Box className="request-card__modal-title">Create a card that fits your needs</Box>
                                <Box className="request-card__modal-paginator">
                                    <span className="request-card__modal-page-indicator">1/3 Steps</span>
                                    <CircleIcon className="request-card__indicator-active" />
                                    <CircleIcon className="request-card__indicator-inactive" />
                                    <CircleIcon className="request-card__indicator-inactive" />
                                </Box>
                            </Box>

                            <Box alignSelf="start">
                                <IconButton onClick={onCardModalClose}>
                                    <CloseIcon sx={{ fontSize: '20px', cursor: 'pointer' }} />
                                </IconButton>
                            </Box>
                        </Box>
                        <Grid container columnSpacing={{ md: 3 }}>
                            <Grid item md={6}>
                                <Box
                                    className={`request-card__card-type-container ${
                                        values.type === CARD_TYPE.VIRTUAL && 'request-card__selected'
                                    }`}
                                    onClick={() => handleCardTypeClick(CARD_TYPE.VIRTUAL, setFieldValue)}>
                                    <Box>
                                        <Box className="request-card__card-image-container">
                                            <img className="request-card__card-image" src={virtualCard} alt="virtual card" />
                                        </Box>
                                        <Box className="request-card__card-type-name">Virtual Card</Box>
                                        <Box className="request-card__card-type-description">
                                            Ready to spend instantly online. Connect to your digital wallet.
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item md={6}>
                                <Box
                                    className={`request-card__card-type-container ${
                                        values.type === CARD_TYPE.PHYSICAL && 'request-card__selected'
                                    }`}
                                    onClick={() => handleCardTypeClick(CARD_TYPE.PHYSICAL, setFieldValue)}>
                                    <Box>
                                        <Box className="request-card__card-image-container">
                                            <img className="request-card__card-image" src={physicalCard} alt="virtual card" />
                                        </Box>
                                        <Box className="request-card__card-type-name">Physical Card</Box>
                                        <Box className="request-card__card-type-description">
                                            Order a physical card to your address. Use online and on the go.
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>

                        <Box display="flex" justifyContent="flex-end">
                            <Button variant="contained" type="submit" form="card-type-form" sx={{ marginTop: '20px' }}>
                                Continue
                            </Button>
                        </Box>
                    </Form>
                </Box>
            )}
        </Formik>
    );
};

export default CardType;
